import { useContext } from 'react';
// import { SupportedLanguages } from '../types/SupportedLanguages';
import LanguageContext, { LanguageContextValue } from '../contexts/LanguageContext';

const useLanguage = (): LanguageContextValue => useContext(LanguageContext);

export default useLanguage;
